import React, {useState, useEffect} from 'react'
import get from "lodash/get";
import { useSelector } from "react-redux";
import { createBookmark, deleteBookmark, fetchBookmarkById } from '../../../../server/handlers/cartoon-mango';
import { LoginPopup } from '../popup/login-popup';

import "./save-button.m.css"
export const SaveButton = ({story}) => {
    const [isSaved, setIsSaved] = useState(0)
    const [showLoginPopup, setShowLoginPoup] = useState(false)
    const storyId = get(story,["id"], null)
    const storyDetail = story

    const member = useSelector(state => {
        return get(state, ["member"], null);
    });
 
    useEffect(()=>{
        fetchBookmarkById(storyId).then(result=>setIsSaved(result.data && result.data.is_bookmarked))
    }, [])
    
    const handleClick = () => {
        if(!member){
            setShowLoginPoup(true)
        }
        else{
            setIsSaved(!isSaved)
            story && !isSaved && createBookmark(storyId, storyDetail)
            isSaved && deleteBookmark(storyId)
        }
    }

    return(
        <React.Fragment>
            <span styleName="wrapper" onClick={handleClick}>
                <i className={isSaved!=1?"material-icons-outlined":"material-icons"}>
                    {isSaved!=1? "bookmark_add" : "bookmark_added"}
                </i>
            </span>
            {showLoginPopup && <LoginPopup showModal={showLoginPopup} setShowModal={setShowLoginPoup}/>}
        </React.Fragment>
    )
}